import { Trans, useTranslation } from 'react-i18next';

import FloatingMessage from '../../FloatingMessage';
import Key from '../key';
import { i18nNS } from '../../../i18n';
import Typography from '../../Typography';
import { Stack } from '@mui/material';
import useInFocusNotification from './vm';

const InFocusNotification = () => {
  const { t } = useTranslation([i18nNS.COMMON]);

  const { isVisible } = useInFocusNotification();

  return (
    <FloatingMessage visible={isVisible}>
      <Typography
        variant="paragraphRegular"
        color="common.white"
        component={Stack}
        direction="row"
        alignItems="center"
        gap={1.25}
      >
        <Trans t={t} ns={i18nNS.COMMON} i18nKey="press_esc_to_start_navigating_between_slides">
          Press <Key>Esc</Key> to start navigating between slides.
        </Trans>
      </Typography>
    </FloatingMessage>
  );
};
export default InFocusNotification;
